<h2 mat-dialog-title class="text-lg font-bold mb-1">
  Acción
</h2>
<mat-dialog-content class="modal-content">
  <form [formGroup]="formData" class="grid grid-cols-1 gap-4">
    <mat-form-field appearance="fill" class="col-span-2">
      <mat-label>Acción</mat-label>
      <mat-select
        matInput
        formControlName="action"
        name="action"
        multiple
        required
      >
        <mat-option *ngFor="let action of actions" [value]="action">{{
          action
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-end">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!formData.valid"
    class="justify-end"
  >
    {{ "Guardar" }}
  </button>
</mat-dialog-actions>